import { dcFactory } from '@deleteagency/dc';
import SearchFilters from './js/search-filters.component';
import SearchFiltersHorizontal from './js/search-filters-horizontal.component';

import SearchFiltersBedroom from './js/search-filters-bedrooms.component';
import SearchFiltersPropertyType from './js/search-filters-property-type.component';
import SearchFiltersPrice from './js/search-filters-price.component';

import './scss/index.scss';

dcFactory.register(SearchFilters);
dcFactory.register(SearchFiltersHorizontal);

dcFactory.register(SearchFiltersBedroom);
dcFactory.register(SearchFiltersPropertyType);
dcFactory.register(SearchFiltersPrice);